import addPersonaViewState from '../actions/addPersonaViewState';
import fetchPersonaPhoto from '../actions/fetchPersonaPhoto';
import getPersonaControlKey from '../utils/getPersonaControlKey';
import getPersonaPhotoQueue from '../utils/getPersonaPhotoQueue';
import mapPersonaToPersonaViewState from '../utils/mapPersonaToPersonaViewState';
import reInitializePersonaBlob from '../actions/reInitializePersonaBlob';
import setPersonaBlobFetchStatus from '../actions/setPersonaBlobFetchStatus';
import shouldFetchPersonaPhoto from '../utils/shouldFetchPersonaPhoto';
import { getStore } from '../store/Store';
import { orchestrator } from 'satcheljs';
import { PersonaBlobFetchStatus } from '../store/schema/PersonaBlob';

export default orchestrator(fetchPersonaPhoto, actionMessage => {
    const { name, emailAddress, personaId, initialGenerationText, personaSize } = actionMessage;
    if (!(name || emailAddress || personaId)) {
        return;
    }
    const personaControlKey = getPersonaControlKey(name, emailAddress, personaId, personaSize);
    const personaControlStore = getStore();
    let viewState = personaControlStore.viewStates.get(personaControlKey);

    if (viewState) {
        if (!shouldFetchPersonaPhoto(personaControlKey)) {
            return;
        }

        // When loading with a snapshot, we lose all cached photos,
        // so we should re-initialize its persona blob state and re-fetch the photo from server.
        reInitializePersonaBlob(personaControlKey);
    } else {
        addPersonaViewState(
            personaControlKey,
            mapPersonaToPersonaViewState(
                name,
                emailAddress,
                personaId,
                initialGenerationText,
                personaSize
            )
        );

        // Previously with MobX2, the object gets patched in-place to be observable; now MobX4 creates a clone of the object.
        // The original object is stale at this point. Hence we re-assign with the fresh store object.
        viewState = personaControlStore.viewStates.get(personaControlKey);
    }

    if (viewState.emailAddress || viewState.personaId) {
        const { name, emailAddress, personaId, personaSize } = viewState;
        getPersonaPhotoQueue.add({ name, emailAddress, personaId, personaSize });
    } else {
        // If email address or personaId doesn't exist, treat it as if download photo failed.
        setPersonaBlobFetchStatus(personaControlKey, PersonaBlobFetchStatus.Failed);
    }
});
